import { positionTooltip, positionTooltipOverlay } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
export const Tooltip = ({ align, children, className, dense, open, orientation, overlay, tooltipRef, width, ...rest }) => {
    const fallbackRef = useRef(null);
    const ref = tooltipRef || fallbackRef;
    useEffect(() => {
        const setTooltipPosition = () => {
            if (overlay) {
                // width eval corresponds with vanilla fullWidth arg in getTooltipModifiers
                if (ref.current)
                    positionTooltipOverlay(ref.current, align, orientation, width === 'full');
            }
            else {
                if (ref.current)
                    positionTooltip(ref.current);
            }
        };
        if (open) {
            setTooltipPosition();
            if (overlay)
                window.addEventListener('scroll', setTooltipPosition);
            window.addEventListener('resize', setTooltipPosition);
        }
        return () => {
            window.removeEventListener('scroll', setTooltipPosition);
            window.removeEventListener('resize', setTooltipPosition);
        };
    }, [ref, align, orientation, overlay, open, width]);
    return (React.createElement("div", { className: cx('tds-tooltip', {
            [`tds-tooltip--orientation-${orientation}`]: orientation,
            [`tds-tooltip--width-${width}`]: width,
            [`tds-tooltip--align-${align}`]: align,
            'tds-tooltip--overlay': overlay,
            'tds-density--dense': dense,
            'tds-tooltip--open': open,
            // only force the tooltip closed if explicitly set to false
            'tds-tooltip--closed': open === false,
        }, className), ref: ref, role: "tooltip", ...rest }, children));
};
